import React from 'react'

const IconCalendarDate = ({ style }) => {
   return (
      <svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' style={style}>
         <rect x='4' y='5' width='16' height='15' rx='2' />
         <line x1='4' y1='10' x2='20' y2='10' />
         <line x1='8' y1='3' x2='8' y2='7' />
         <line x1='16' y1='3' x2='16' y2='7' />
      </svg>
   )
}
export default IconCalendarDate
